import { useEffect } from "react";
import ReactDOM from "react-dom";
import style from './Modal.module.css';
import Card from "./Card";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

const modalContainer = document.getElementById("app_modal");

const Modal = (props) => {
  const modalType = ['adaptive', 'full'].includes(props.type) ? props.type : 'alert';
  const { close } = props; 

  useEffect(() => {
    document.body.style.overflow = "hidden";

    const closeModalHandler = () => {
      if (close) {
        close();
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeModalHandler();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [close]);

  const closeModalHandler = () => {
    if (close) {
      close();
    }
  };

  return (
    <>
      {ReactDOM.createPortal(
        <div className={`${style.modal} ${style[modalType]}`}>
          <div onClick={closeModalHandler} className={style.overlay}></div>
          <div className={style['modal-content_wrapper']}>
            {
             modalType === 'full' && (
              <div className={style['modal-full_action']}>
                <div className="form-group_row form-group_right">
                  <button className="button button-icon button-icon_only button-danger" onClick={closeModalHandler}><FontAwesomeIcon className="icon" icon={faXmark} /></button>
                </div>
              </div>
             ) 
            }
            <Card
              theme={props.theme}
              header={props.header}
              footer={props.footer}
              className={style['modal-card']}
              spaced={true}
            >
              {props.children}
            </Card>
          </div>
        </div>,
        modalContainer
      )}
    </>
  );
};

export default Modal;